export const i18n = {
  fr: {
    "nav.home": "Accueil",
    "nav.prestations": "Prestations",
    "nav.software": "Software",
    "nav.references": "Références",
    "nav.resources": "Ressources",
    "nav.recruitment": "Recrutement",
    "nav.contact": "Contact",
    "nav.demo": "Demander une démo",
    "nav.pricing": "Voir les tarifs",
    "nav.quote": "Demander un devis",
    "nav.seeall": "Tout voir",
    "nav.login": "Se connecter",
    "nav.register": "S'inscrire",

    "aria.theme": "Basculer le thème",
    "aria.menu.open": "Ouvrir le menu",
    "aria.menu.close": "Fermer le menu",
    "mobile.menu": "Menu",

    "btn.contact": "Nous contacter",
    "btn.whatsapp": "WhatsApp",
    "btn.meeting": "Prendre rendez-vous",
    "btn.soon": "Bientôt disponible",
    "btn.choose": "Choisir",
    "btn.send": "Envoyer",

    "home.title":
      "Management de Projet — Construction & Industrie - De la vision à la réussite, avec Stratégie et Agilité.",
    "home.subtitle":
      "Nous accompagnons nos clients dans leurs projets de construction et d'industrie grâce à une vision claire, des solutions innovantes et une agilité exceptionnelle.",
    "home.card.1": "Pilotage & Coordination",
    "home.card.2": "Études & Méthodes & Synthèse",
    "home.card.3": "Suivi & KPI",
    "home.card.desc": "Solutions pragmatiques, impact mesurable.",
    "home.card.link": "Voir les prestations →",
    "home.cta.presta": "Découvrir les Prestations",
    "home.cta.software": "Voir le Software",

    "crumb.home": "Accueil",

    "presta.title":
      "Prestations — De la vision à la réussite, avec Stratégie et Agilité.",
    "presta.subtitle":
      "Nous accompagnons nos clients dans leurs projets de construction et d'industrie grâce à une vision claire, des solutions innovantes et une agilité exceptionnelle. Pas de tarification affichée\u00A0: <strong>devis personnalisé</strong>.",

    "chip.direction": "Direction",
    "chip.pilotage": "Pilotage",
    "chip.etudes": "Études & Synthèse",
    "chip.suivi": "Suivi",
    "chip.optimisation": "Optimisation",
    "chip.logistique": "Logistique",
    "chip.quote": "Demander un devis",

    "presta.direction": "Direction de projet",
    "presta.direction.b1": "Direction externalisée de projet",
    "presta.direction.b2": "Leadership, gouvernance, arbitrages",
    "presta.direction.b3": "Coordination multi-lots & parties prenantes",

    "presta.pilotage": "Pilotage & Coordination",
    "presta.pilotage.b1": "Gouvernance, PMO, comités",
    "presta.pilotage.b2": "Planification multi-lots (MSP/Primavera)",
    "presta.pilotage.b3": "Gestion parties prenantes",

    "presta.etudes": "Études & Méthodes & Synthèse",
    "presta.etudes.b1": "Dessin technique, synthèse 2D",
    "presta.etudes.b2": "Méthodes d'exécution, phasage",
    "presta.etudes.b3": "Maquette numérique (BIM)",

    "presta.suivi": "Suivi & Contrôle",
    "presta.suivi.b1": "Tableaux de bord, KPI",
    "presta.suivi.b2": "Qualité, QHSE, audits",
    "presta.suivi.b3": "Avancement physique/financier",

    "presta.optim": "Optimisation & Performance",
    "presta.optim.b1": "Lean construction",
    "presta.optim.b2": "Gestion des risques & claims",
    "presta.optim.b3": "Réduction coûts/délais",

    "presta.log": "Logistique & Supply Chain",
    "presta.log.b1": "Empreinte Carbone",
    "presta.log.b2": "Coordination fournisseurs",
    "presta.log.b3": "Logistique chantier/usine",

    "soft.title": "Software — une plateforme digitale unique pour vos projets",
    "soft.subtitle": "Découvrez nos solutions digitales",

    "soft.plan.title": "Planification , Avancement Reste à Faire ( PAR )",
    "soft.collab.title": "Collab Hub",
    "soft.log.title": "Logistique & Supply Chain",
    "soft.qual.title": "QHSE & BREAM Tracking",

    "soft.plan.b1": "PAR sur Tableur",
    "soft.plan.b2": "Scénarios what-if",
    "soft.plan.b3": "PAR sur Plan",

    "soft.log.b1": "Planification et Suivi Livraison",
    "soft.log.b2": "Empreinte Carbone",
    "soft.log.b3": "Suivi BL, Bon de commande , Facture",

    "soft.qual.b1": "Audits & conformité",
    "soft.qual.b2": "Plans d'actions",
    "soft.qual.b3": "Rapports PDF",

    "footer.value": "De la vision à la réussite.",
    "footer.value.sub":
      "Accélérez vos projets Industrie & Construction avec des solutions agiles.",
    "footer.col.presta": "Prestations",
    "footer.col.software": "Software",
    "footer.col.company": "Entreprise",
    "footer.col.legal": "Légal",
    "footer.link.references": "Références",
    "footer.link.resources": "Ressources",
    "footer.link.recruitment": "Recrutement",
    "footer.link.contact": "Contact",
    "footer.link.legal": "Mentions légales",
    "footer.link.legalLink": "https://www.stragilia.com/policies/legal_fr.pdf",
    "footer.link.terms_and_conditions_of_subscription": "Conditions générales d'abonnement",
    "footer.link.terms_and_conditions_of_subscription_link": "https://www.stragilia.com/policies/cga_fr.pdf",
    "footer.link.terms_and_conditions_of_use": "General Terms and Conditions of use",
    "footer.link.terms_and_conditions_of_use_link": "https://www.stragilia.com/policies/cgu_fr.pdf",
    "footer.link.privacy": "Politique de confidentialité",
    "footer.link.privacy_link": "/privacy",
    "footer.link.cookies": "Cookies",
    "footer.link.sitemap": "Sitemap",
    "footer.back": "Haut de page",
    "footer.copyright": "Tous droits réservés",

    "cookies.title": "Gestion des cookies",
    "cookies.intro": "Nous utilisons des cookies pour améliorer votre expérience, mesurer l'audience, et personnaliser le contenu. Vous pouvez accepter tous les cookies, les refuser, ou personnaliser vos choix par catégorie.",
    "cookies.accept_all": "Tout accepter",
    "cookies.reject_all": "Tout refuser",
    "cookies.saved": "Vos préférences ont été enregistrées avec succès.",
    "cookies.preferences": "Préférences de cookies",
    "cookies.necessary": "Strictement nécessaires",
    "cookies.necessary_desc": "Indispensables au fonctionnement du site. Toujours actifs.",
    "cookies.performance": "Performance & Analytics",
    "cookies.performance_desc": "Nous aide à comprendre l'utilisation du site (statistiques anonymisées).",
    "cookies.functional": "Fonctionnels",
    "cookies.functional_desc": "Enregistre vos préférences (langue, région) et améliore certaines fonctionnalités.",
    "cookies.advertising": "Publicité / Ciblage",
    "cookies.advertising_desc": "Permet une personnalisation publicitaire et le suivi inter-sites.",
    "cookies.always_active": "Toujours actifs",
    "cookies.footer_note": "Vous pouvez modifier vos préférences à tout moment en revenant sur cette page. Pour plus d'informations, consultez notre",
    "cookies.privacy_link": "Politique de confidentialité",

    "pricing.title": "Tarification",
    "pricing.subtitle": "Choisissez le plan adapté à vos besoins. Tous nos plans incluent un support dédié.",
    "pricing.period": "/ mois",
    "pricing.custom": "Sur mesure",
    "pricing.popular": "Populaire",
    "pricing.cta": "Commencer",
    "pricing.starter.name": "Starter",
    "pricing.starter.desc": "1 administrateur, 2 utilisateurs",
    "pricing.starter.feat1": "Tableau de bord de base",
    "pricing.starter.feat2": "Gestion des projets",
    "pricing.starter.feat3": "Support email",
    "pricing.starter.feat4": "Mises à jour mensuelles",
    "pricing.pro.name": "Professionnel",
    "pricing.pro.desc": "1 administrateur, 10 utilisateurs",
    "pricing.pro.feat1": "Tout du plan Starter",
    "pricing.pro.feat2": "Tableau de bord avancé",
    "pricing.pro.feat3": "Rapports et analytics",
    "pricing.pro.feat4": "Support prioritaire",
    "pricing.pro.feat5": "Intégrations personnalisées",
    "pricing.enterprise.name": "Enterprise",
    "pricing.enterprise.desc": "Utilisateurs illimités et fonctionnalités sur mesure",
    "pricing.enterprise.feat1": "Tout du plan Professionnel",
    "pricing.enterprise.feat2": "Utilisateurs illimités",
    "pricing.enterprise.feat3": "Support dédié 24/7",
    "pricing.enterprise.feat4": "Formation personnalisée",
    "pricing.enterprise.feat5": "SLA garantie",
    "pricing.help.title": "Besoin d'aide pour choisir ?",
    "pricing.help.desc": "Contactez-nous pour discuter de vos besoins spécifiques et trouver le plan parfait pour votre équipe.",
    "pricing.contact.name": "Sur mesure",
    "pricing.contact.desc": "Solution personnalisée pour vos besoins spécifiques",
    "pricing.contact.feat1": "Configuration sur mesure",
    "pricing.contact.feat2": "Tarification flexible",
    "pricing.contact.feat3": "Support dédié",
    "pricing.contact.feat4": "Intégrations personnalisées",
    "pricing.contact.cta": "Contactez-nous",

    "contact.title": "Nous contacter / Demander un devis",
    "contact.subtitle":
      "Expliquez-nous votre besoin — nous revenons vers vous avec une proposition adaptée.",
    "form.name": "Nom complet",
    "form.email": "Email",
    "form.phone": "Téléphone",
    "form.company": "Société",
    "form.subject": "Sujet",
    "form.msg": "Message",
    "form.subject.presta": "Prestations",
    "form.subject.module": "Module (software)",
    "form.subject.other": "Autre",
    "form.placeholder.name": "Votre nom",
    "form.placeholder.email": "votre@email.com",
    "form.placeholder.phone": "+33 ...",
    "form.placeholder.company": "Votre société",
    "form.placeholder.msg":
      "Décrivez vos besoins, délais, contraintes...",
    "form.consent": "J'accepte d'être contacté(e) au sujet de ma demande.",
    "form.send": "Envoyer la demande",
    "form.sending": "Envoi en cours...",
    "form.success": "Message envoyé avec succès ! Nous vous répondrons bientôt.",
    "form.error.required": "Merci de remplir tous les champs obligatoires.",
    "form.error.consent": "Veuillez accepter d'être contacté(e).",
    "form.error.rate_limit": "Trop de demandes. Veuillez réessayer dans une heure.",
    "form.error.generic": "Une erreur est survenue. Veuillez réessayer.",
    "form.data":
      "Vos données sont utilisées uniquement pour répondre à votre demande.",

    "jobs.title": "Recrutement — Rejoignez {company}",
    "jobs.subtitle":
      "Postulez en <strong>candidature spontanée</strong> ou <strong>répondez à une offre</strong>. Partagez un lien vers votre CV/Portfolio (Drive, Dropbox, GitHub…).",
    "jobs.type": "Type de candidature",
    "jobs.type.spont": "Candidature spontanée",
    "jobs.type.offer": "Réponse à une offre",
    "jobs.role": "Poste visé",
    "jobs.ref": "Référence de l'offre",
    "jobs.linkedin": "Profil LinkedIn (lien)",
    "jobs.portfolio": "CV / Portfolio (lien)",
    "jobs.consent":
      "J'accepte d'être contacté(e) au sujet de ma candidature.",
    "jobs.send": "Envoyer la candidature",
    "jobs.data":
      "Vos données sont utilisées uniquement pour l'étude de votre candidature.",
    "jobs.quick": "Entretien express",
    "jobs.anchor.spont": "Candidature spontanée",
    "jobs.anchor.offer": "Réponse à une offre",
    "jobs.placeholder.role": "Ex. Chef de projet, PMO...",
    "jobs.placeholder.ref": "Ex. REF-2025-001",
    "jobs.placeholder.linkedin": "https://linkedin.com/in/...",
    "jobs.placeholder.portfolio": "Lien Drive/Dropbox/GitHub...",
  },
  en: {
    "nav.home": "Home",
    "nav.prestations": "Services",
    "nav.software": "Software",
    "nav.references": "References",
    "nav.resources": "Resources",
    "nav.recruitment": "Careers",
    "nav.contact": "Contact",
    "nav.demo": "Request a demo",
    "nav.pricing": "See Pricing",
    "nav.quote": "Request a quote",
    "nav.seeall": "See all",
    "nav.login": "Login",
    "nav.register": "Register",

    "aria.theme": "Toggle theme",
    "aria.menu.open": "Open menu",
    "aria.menu.close": "Close menu",
    "mobile.menu": "Menu",

    "btn.contact": "Contact us",
    "btn.whatsapp": "WhatsApp",
    "btn.meeting": "Book a meeting",
    "btn.soon": "Coming soon",
    "btn.choose": "Choose",
    "btn.send": "Send",

    "home.title":
      "Project Management — Construction & Industry — From vision to success, with Strategy and Agility.",
    "home.subtitle":
      "We support our clients' construction and industrial projects with a clear vision, innovative solutions, and exceptional agility.",
    "home.card.1": "Steering & Coordination",
    "home.card.2": "Studies, Methods & Synthesis",
    "home.card.3": "Monitoring & KPIs",
    "home.card.desc": "Pragmatic solutions, measurable impact.",
    "home.card.link": "Browse services →",
    "home.cta.presta": "Explore Services",
    "home.cta.software": "View Software",

    "crumb.home": "Home",

    "presta.title":
      "Services — From vision to success, with Strategy and Agility.",
    "presta.subtitle":
      "We support construction & industrial projects with a clear vision, innovative solutions, and agility. No public pricing: <strong>custom quote</strong>.",

    "chip.direction": "Direction",
    "chip.pilotage": "Steering",
    "chip.etudes": "Studies & Synthesis",
    "chip.suivi": "Monitoring",
    "chip.optimisation": "Optimization",
    "chip.logistique": "Logistics",
    "chip.quote": "Request a quote",

    "presta.direction": "Project Direction",
    "presta.direction.b1": "Externalized project direction",
    "presta.direction.b2": "Leadership, governance, arbitration",
    "presta.direction.b3": "Multi-lot & stakeholder coordination",

    "presta.pilotage": "Steering & Coordination",
    "presta.pilotage.b1": "Governance, PMO, committees",
    "presta.pilotage.b2": "Multi-lot planning (MSP/Primavera)",
    "presta.pilotage.b3": "Stakeholder management",

    "presta.etudes": "Studies, Methods & Synthesis",
    "presta.etudes.b1": "Technical drawing, 2D coordination",
    "presta.etudes.b2": "Execution methods, phasing",
    "presta.etudes.b3": "Digital model (BIM)",

    "presta.suivi": "Monitoring & Control",
    "presta.suivi.b1": "Dashboards, KPIs",
    "presta.suivi.b2": "Quality, QHSE, audits",
    "presta.suivi.b3": "Physical/financial progress",

    "presta.optim": "Optimization & Performance",
    "presta.optim.b1": "Lean construction",
    "presta.optim.b2": "Risk & claims management",
    "presta.optim.b3": "Cost/time reduction",

    "presta.log": "Logistics & Supply Chain",
    "presta.log.b1": "Carbon Footprint",
    "presta.log.b2": "Supplier coordination",
    "presta.log.b3": "Site/plant logistics",

    "soft.title": "Software — a single digital platform for your projects",
    "soft.subtitle": "Explore our digital solutions",

    "soft.plan.title": "Planning, Remaining Work Progress (PAR)",
    "soft.collab.title": "Collab Hub",
    "soft.log.title": "Logistics & Supply Chain",
    "soft.qual.title": "QHSE & BREAM Tracking",

    "soft.plan.b1": "PAR in Spreadsheet",
    "soft.plan.b2": "What-if scenarios",
    "soft.plan.b3": "PAR on Schedule",

    "soft.log.b1": "Delivery Planning & Tracking",
    "soft.log.b2": "Carbon Footprint",
    "soft.log.b3": "GRN, PO & Invoices tracking",

    "soft.qual.b1": "Audits & compliance",
    "soft.qual.b2": "Action plans",
    "soft.qual.b3": "PDF reports",

    "footer.value": "From vision to success.",
    "footer.value.sub":
      "Accelerate Construction & Industry projects with agile solutions.",
    "footer.col.presta": "Services",
    "footer.col.software": "Software",
    "footer.col.company": "Company",
    "footer.col.legal": "Legal",
    "footer.link.references": "References",
    "footer.link.resources": "Resources",
    "footer.link.recruitment": "Careers",
    "footer.link.contact": "Contact",
    "footer.link.legal": "Legal notice",
    "footer.link.legalLink": "https://www.stragilia.com/policies/legal_en.pdf",
    "footer.link.privacy": "Privacy policy",
    "footer.link.privacy_link": "/privacy",
    "footer.link.terms_and_conditions_of_subscription": "General Terms and Conditions of Subscription",
    "footer.link.terms_and_conditions_of_subscription_link": "https://www.stragilia.com/policies/cga_en.pdf",
    "footer.link.terms_and_conditions_of_use": "General Terms and Conditions of use",
    "footer.link.terms_and_conditions_of_use_link": "https://www.stragilia.com/policies/cgu_fr.pdf",
    "footer.link.cookies": "Cookies",
    "footer.link.sitemap": "Sitemap",
    "footer.back": "Back to top",
    "footer.copyright": "All rights reserved",

    "cookies.title": "Cookie Preferences",
    "cookies.intro": "We use cookies to improve your experience, measure audience, and personalize content. You can accept all cookies, reject them, or customize your choices by category.",
    "cookies.accept_all": "Accept All",
    "cookies.reject_all": "Reject All",
    "cookies.saved": "Your preferences have been saved successfully.",
    "cookies.preferences": "Cookie Preferences",
    "cookies.necessary": "Strictly Necessary",
    "cookies.necessary_desc": "Essential for site functionality. Always active.",
    "cookies.performance": "Performance & Analytics",
    "cookies.performance_desc": "Helps us understand site usage (anonymized statistics).",
    "cookies.functional": "Functional",
    "cookies.functional_desc": "Stores your preferences (language, region) and improves certain features.",
    "cookies.advertising": "Advertising / Targeting",
    "cookies.advertising_desc": "Enables advertising personalization and cross-site tracking.",
    "cookies.always_active": "Always active",
    "cookies.footer_note": "You can change your preferences at any time by returning to this page. For more information, see our",
    "cookies.privacy_link": "Privacy Policy",

    "pricing.title": "Pricing",
    "pricing.subtitle": "Choose the plan that fits your needs. All plans include dedicated support.",
    "pricing.period": "/ month",
    "pricing.custom": "Custom",
    "pricing.popular": "Popular",
    "pricing.cta": "Get Started",
    "pricing.starter.name": "Starter",
    "pricing.starter.desc": "1 admin, 2 users",
    "pricing.starter.feat1": "Basic dashboard",
    "pricing.starter.feat2": "Project management",
    "pricing.starter.feat3": "Email support",
    "pricing.starter.feat4": "Monthly updates",
    "pricing.pro.name": "Professional",
    "pricing.pro.desc": "1 admin, 10 users",
    "pricing.pro.feat1": "Everything in Starter",
    "pricing.pro.feat2": "Advanced dashboard",
    "pricing.pro.feat3": "Reports and analytics",
    "pricing.pro.feat4": "Priority support",
    "pricing.pro.feat5": "Custom integrations",
    "pricing.enterprise.name": "Enterprise",
    "pricing.enterprise.desc": "Unlimited users and custom features",
    "pricing.enterprise.feat1": "Everything in Professional",
    "pricing.enterprise.feat2": "Unlimited users",
    "pricing.enterprise.feat3": "24/7 dedicated support",
    "pricing.enterprise.feat4": "Custom training",
    "pricing.enterprise.feat5": "Guaranteed SLA",
    "pricing.help.title": "Need help choosing?",
    "pricing.help.desc": "Contact us to discuss your specific needs and find the perfect plan for your team.",
    "pricing.contact.name": "Custom",
    "pricing.contact.desc": "Tailored solution for your specific needs",
    "pricing.contact.feat1": "Custom configuration",
    "pricing.contact.feat2": "Flexible pricing",
    "pricing.contact.feat3": "Dedicated support",
    "pricing.contact.feat4": "Custom integrations",
    "pricing.contact.cta": "Contact Us",

    "contact.title": "Contact us / Request a quote",
    "contact.subtitle":
      "Tell us about your needs — we'll get back to you with a tailored proposal.",
    "form.name": "Full name",
    "form.email": "Email",
    "form.phone": "Phone",
    "form.company": "Company",
    "form.subject": "Subject",
    "form.msg": "Message",
    "form.subject.presta": "Services",
    "form.subject.module": "Module (software)",
    "form.subject.other": "Other",
    "form.placeholder.name": "Your name",
    "form.placeholder.email": "your@email.com",
    "form.placeholder.phone": "+33 ...",
    "form.placeholder.company": "Your company",
    "form.placeholder.msg":
      "Describe your needs, deadlines, constraints...",
    "form.consent": "I agree to be contacted regarding my request.",
    "form.send": "Send request",
    "form.sending": "Sending...",
    "form.success": "Message sent successfully! We'll get back to you soon.",
    "form.error.required": "Please fill in all required fields.",
    "form.error.consent": "Please accept to be contacted.",
    "form.error.rate_limit": "Too many requests. Please try again in an hour.",
    "form.error.generic": "An error occurred. Please try again.",
    "form.data": "Your data will only be used to answer your request.",

    "jobs.title": "Careers — Join {company}",
    "jobs.subtitle":
      "Apply as a <strong>spontaneous application</strong> or <strong>to an open role</strong>. Share a link to your CV/Portfolio (Drive, Dropbox, GitHub…).",
    "jobs.type": "Application type",
    "jobs.type.spont": "Spontaneous application",
    "jobs.type.offer": "Response to a job offer",
    "jobs.role": "Target role",
    "jobs.ref": "Job reference",
    "jobs.linkedin": "LinkedIn profile (link)",
    "jobs.portfolio": "CV / Portfolio (link)",
    "jobs.consent":
      "I agree to be contacted regarding my application.",
    "jobs.send": "Send application",
    "jobs.data":
      "Your data will only be used to review your application.",
    "jobs.quick": "Express interview",
    "jobs.anchor.spont": "Spontaneous application",
    "jobs.anchor.offer": "Apply to a job",
    "jobs.placeholder.role": "e.g., Project manager, PMO...",
    "jobs.placeholder.ref": "e.g., REF-2025-001",
    "jobs.placeholder.linkedin": "https://linkedin.com/in/...",
    "jobs.placeholder.portfolio": "Drive/Dropbox/GitHub link...",
  },
};
